export default "__VITE_ASSET__eKJE7lB$__"